export default __webpack_public_path__ + "static/media/img-0733-latvia-full-face.fa4e50af.png";